<style scoped>

.img-temp-list {
    padding-left: 0;
    display: flex;
    align-items: center;
    flex-warp: warp;
}

.img-temp-item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    display: inline-block;
    position: relative;
}

.img-temp-item img {
    width: 100%;
    height: 100%;
}
.img-temp-item:hover .img-action {
    opacity: 1;
}

.img-temp-item .img-action {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    opacity: 0;
}
.img-action i {
    font-size: 20px;
    color: #fff;
    margin-left: 15px;
    cursor: pointer;
}
.img-action i:first-child {
    margin-left: 0;
}
</style>

<template>

<el-row>
    <el-col :span="18">

        <el-form :model="usedCarForm" :rules="rules" addAction="privateUsedCar/savePrivateUsedCar.action" editAction="privateUsedCar/editPrivateUsedCar.action" label-width="150px" ref="ruleForm" selectAction="privateUsedCar/selectPrivateUsedCar.action" v-form>

            <el-form-item label="选择车型" prop="categoryId">
                <brand-and-series-categories-select :categoriesMultiple="false" @onChanged="carCategoryChange" brandPlaceholder="品牌（单选）" categoriesPlaceholder="车型（单选）" ref="brand-and-series-select" seriesPlaceholder="车系（单选）"></brand-and-series-categories-select>
            </el-form-item>

            <el-form-item label="上牌地点" prop="licenseAddress">
                <search-area-input ref="business-address" v-model="usedCarForm.licenseAddress" placeholder="请选择（支持搜索联想输入）" :defaultValue="usedCarForm.licenseAddress" @onChenged="onLicenseAddressChanged"></search-area-input>
            </el-form-item>

            <el-form-item label="上牌时间" prop="licenseTime">
                <el-date-picker placeholder="选择上牌时间" type="month" v-model="usedCarForm.licenseTime">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="行驶里程" prop="mileage">
                <el-input placeholder="请填写0-100之间的整数（单位万公里）" v-model="usedCarForm.mileage"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="releasePersonPhone">
                <el-input placeholder="请填写正确的11位电话号码" v-model="usedCarForm.releasePersonPhone"></el-input>
            </el-form-item>

            <el-form-item label="车辆售价" prop="sellingPrice">
                <el-input placeholder="请填写0-1000之间的整数（单位万元）" type="number" v-model="usedCarForm.sellingPrice"></el-input>
                <p style="color:#666;"><span style="color:red;">提示：车辆售价仅作展示使用，不作为最终成交依据！</span></p>
            </el-form-item>
            <el-form-item label="车辆照片" prop="photo">
                <draggable v-model="usedCarForm.photo" tag="ul" class="img-temp-list" draggable=".img-temp-item">
                    <li class="img-temp-item" v-for="(item, i) in usedCarForm.photo" :key="i">
                        <img :src="item.url" />
                        <div class="img-action">
                            <i class="el-icon-zoom-in" @click="handlePictureCardPreview(item)"></i>
                            <i class="el-icon-delete" @click="removeFile(usedCarForm.photo,i)"></i>
                        </div>
                    </li>
                    <el-upload
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload"
                            :data="{floder:'localCarUsedCar'}"
                            :file-list="usedCarForm.photo"
                            :http-request="onHttpRequest"
                            :limit="9"
                            accept="image/*"
                            action="upload/uploadPic"
                            list-type="picture-card"
                            multiple
                               ref="photo"
                            v-model="usedCarForm.photo">

                        <i class="el-icon-plus"></i>
                    </el-upload>
                </draggable>
                <p style="color:#666;"><span style="color:red;">自传尺寸：750 * 460像素的，最多9张</span></p>
            </el-form-item>
            <el-form-item label="车辆标签" prop="descTag">
                <el-select v-model="usedCarForm.descTag" multiple placeholder="请选择">
                    <el-option label="随时看车" value="随时看车"></el-option>
                    <el-option label="价格可以" value="价格可以"></el-option>
                    <el-option label="正常保养" value="正常保养"></el-option>
                    <el-option label="公里数低" value="公里数低"></el-option>
                    <el-option label="省油" value="省油"></el-option>
                    <el-option label="操控好" value="操控好"></el-option>
                    <el-option label="车况良好" value="车况良好"></el-option>
                    <el-option label="9成新" value="9成新"></el-option>
                    <el-option label="缺钱贱卖" value="缺钱贱卖"></el-option>
                    <el-option label="个人车" value="个人车"></el-option>
                    <el-option label="商家车" value="商家车"></el-option>
                    <el-option label="0次过户" value="0次过户"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="车辆描述" prop="descContent">
                <el-input placeholder="选填 比如：车辆碰撞，外观描述等（建议300字以内）" type="textarea" v-model="usedCarForm.descContent"></el-input>
            </el-form-item>

            <el-form-item label="渠道" prop="channelId" v-belong-to-admin>
                <channel-select ref="channel" @change="onChannelChanged" :disabled="usedCarForm.id?true:false"></channel-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">确定发布</el-button>
            </el-form-item>

        </el-form>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </el-col>

</el-row>

</template>

<script>

import BasicPager from '../../../mixins/BasicPager'
import Config from '@/framework/configs/Config'
import BrandAndSeriesCategoriesSelect from '@/components/BrandAndSeriesCategoriesSelect'
import cityCascader from '@/components/cityCascader'
import channelSelect from '@/components/channelSelect'
import SearchAreaInput from '@/components/SearchAreaInput'
import draggable from 'vuedraggable'
export default {

  name: 'saveUsedCarInfo',
  extends: BasicPager,
  components: {
    draggable,
    BrandAndSeriesCategoriesSelect,
    cityCascader,
    channelSelect,
    SearchAreaInput
  },
  data: function () {
    var checkTagCount = (rule, value, callback) => {
      if (value.length > 3) {
        return callback(new Error('最多选择三个标签）'))
      }
      callback()
    }
    var checkPrice = (rule, value, callback) => {
      if (value < 0 || value > 1000) {
        return callback(new Error('请填写0-1000之间的整数（单位万元）'))
      }
      callback()
    }

    var checkMileage = (rule, value, callback) => {
      if (value < 0 || value > 100) {
        return callback(new Error('请填写0-100之间的数值（单位万公里）'))
      }

      let match = value + ''.match(/^\d+(\.\d{1,2})?$/)
      if (!match) {
        callback(new Error('小数点只能保留两位哦！'))
      }

      callback()
    }

    return {
      dialogVisible: false,
      dialogImageUrl: null,
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      usedCarForm: {
        id: null,
        fullName: null,
        licenseAddress: null,
        licenseTime: null,
        brandId: null,
        seriesId: null,
        categoryId: null,
        mileage: null,
        sellingPrice: null,
        officePrice: null,
        levelName: null,
        releasePersonPhone: null,
        channelId: null,
        descTag: [],
        descContent: null,
        photo: []
      },
      rules: {
        categoryId: [{
          required: true,
          message: '车型数据不能为空'
        }],
        fullName: [{
          required: true,
          message: '车辆名称不能为空'
        }],
        licenseAddress: [{
          required: true,
          message: '上牌地点不能为空',
          trigger: 'change'
        }],
        licenseTime: [{
          required: true,
          message: '上牌时间不能为空'
        }],
        mileage: [{
          required: true,
          message: '行驶里程不能为空'
        }, {
          validator: checkMileage,
          trigger: 'blur'
        }],
        sellingPrice: [{
          required: true,
          message: '车辆售价不能为空'
        }, {
          validator: checkPrice,
          trigger: 'blur'
        }],
        releasePersonPhone: [{
          required: true,
          message: '联系电话不能为空'
        }, {
          max: 11,
          message: '电话不能超过11位',
          trigger: 'blur'
        }],
        descTag: [{
          validator: checkTagCount,
          trigger: 'change'
        }],
        photo: [{
          required: true,
          message: '图片不能为空！',
          trigger: 'change'
        }]
      }
    }
  },
  created () {
    let params = this.$route.query
    if (params.id) {
      this.usedCarForm.id = params.id
    }
    if (this.loginInfo.loginPath == 'channel') {
      this.usedCarForm.channelId = this.loginInfo.id
    }
  },
  methods: {
    removeFile (list, index) {
      list.splice(index, 1)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleDownload (file) {
      console.log(file)
    },
    onLicenseAddressChanged: function (addressInfo) {
      let city = addressInfo.province + ' ' + addressInfo.city
      this.usedCarForm.licenseAddress = city
    },
    carCategoryChange: function (brandInfo, seriesInfo, categoriesInfo) {
      // 商品名
      this.usedCarForm.fullName = brandInfo.name + ' ' + seriesInfo.name + ' ' + categoriesInfo.name

      // 官方指定价
      this.usedCarForm.officePrice = categoriesInfo.price
      this.usedCarForm.levelName = seriesInfo.levelName

      // 品牌车系车型
      this.usedCarForm.brandId = brandInfo.id
      this.usedCarForm.seriesId = seriesInfo.id
      this.usedCarForm.categoryId = categoriesInfo.id
    },
    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传图片大小不能超过 15MB!')
          reject(new Error('上传图片大小不能超过 15MB!'))
          return
        }

        if (_this.usedCarForm.photo.length >= 9) {
          _this.$message.error('最多只能上传9张!')
          reject(new Error('最多只能上传9张!'))
          return
        }
        resolve()
      })
      return promise
    },
    onFilterParams: function (params) {
      params.sellingPrice = parseInt(params.sellingPrice * 1000000)
      params.officePrice = parseInt(params.officePrice * 100)

      // 只保留省市
      let licenseAddress = params.licenseAddress
      if (licenseAddress) {
        let addr = licenseAddress.split(' ')
        if (addr && addr.length == 3) {
          params.licenseAddress = addr[0] + ' ' + addr[1]
        }
      }
    },
    onSelectInfo: function (dataInfo) {
      this.usedCarForm.sellingPrice = new Number(dataInfo.datas.sellingPrice / 1000000).valueOf()
      this.usedCarForm.officePrice = new Number(dataInfo.datas.officePrice / 100).valueOf()
      if (dataInfo.datas.descTag) {
        this.usedCarForm.descTag = JSON.parse(dataInfo.datas.descTag)
      }

      let brandAndSeriesSelect = this.$refs['brand-and-series-select']
      if (brandAndSeriesSelect) {
        brandAndSeriesSelect.setValue(dataInfo.datas.brandId, dataInfo.datas.seriesId, dataInfo.datas.categoryId)
      }
      this.$refs['channel'].settingDefaultChannelInfo({
        id: dataInfo.datas.channelId,
        channelName: dataInfo.datas.channelName
      })
    },
    onChannelChanged (channelId) {
      this.usedCarForm.channelId = channelId
    }
  }
}

</script>
